import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';

export const useApiFavorites = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const GetAllCorreosFavoritos = async () => {
    return runApi('Favoritos/GetAllCorreosFavoritos', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const CreateCorreoFavorito = async (correo: string, nombre: string) => {
    return runApi('Favoritos/createCorreoFavorito', 'POST', { correo, nombre }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return false;
      }
      else {
        return true;
      }
    });
  };

  const DeleteCorreoFavorito = async (id: number) => {
    return runApi('Favoritos/deleteCorreoFavorito', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return false;
      }
      else {
        return true;
      }
    });
  }

  return { GetAllCorreosFavoritos, CreateCorreoFavorito, DeleteCorreoFavorito };
};
